var _g, _ellipse, _path, _g2, _ellipse2, _path2, _g3, _ellipse3, _path3, _rect, _rect2, _rect3, _path4, _g4, _ellipse4, _path5, _g5, _ellipse5, _path6, _g6, _ellipse6, _path7, _g7, _g8, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpertServices = function SvgExpertServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 538,
    height: 445,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#expert_services_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 54,
    x: 84.228,
    y: 48,
    fill: "#fff",
    rx: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 9,
    x: 139.229,
    y: 62,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 9,
    x: 139.229,
    y: 77,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 9,
    x: 231.229,
    y: 77,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    x: 377.229,
    y: 77,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 9,
    x: 348.229,
    y: 62,
    fill: "#EDEDED",
    rx: 4.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.729,
    cy: 74,
    fill: "#3B7CC9",
    rx: 15.5,
    ry: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.188,
    d: "M111.727 72.917a3.167 3.167 0 1 0 0-6.334 3.167 3.167 0 0 0 0 6.334ZM118.06 78.854c0 1.967 0 3.563-6.333 3.563s-6.333-1.596-6.333-3.563 2.835-3.562 6.333-3.562c3.497 0 6.333 1.595 6.333 3.562Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#expert_services_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 54,
    x: 84.228,
    y: 110,
    fill: "#fff",
    rx: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 9,
    x: 139.229,
    y: 124,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 9,
    x: 139.229,
    y: 139,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 9,
    x: 231.229,
    y: 139,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    x: 377.229,
    y: 139,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 9,
    x: 348.229,
    y: 124,
    fill: "#EDEDED",
    rx: 4.5
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.729,
    cy: 136,
    fill: "#3B7CC9",
    rx: 15.5,
    ry: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.188,
    d: "M111.727 134.916a3.166 3.166 0 1 0 .001-6.333 3.166 3.166 0 0 0-.001 6.333ZM118.06 140.854c0 1.967 0 3.563-6.333 3.563s-6.333-1.596-6.333-3.563 2.835-3.562 6.333-3.562c3.497 0 6.333 1.595 6.333 3.562Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#expert_services_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 481.998,
    height: 62.988,
    x: 28.229,
    y: 171.012,
    stroke: "#51C394",
    strokeWidth: 2,
    rx: 4.207
  }), /*#__PURE__*/React.createElement("rect", {
    width: 479.998,
    height: 60.988,
    x: 29.229,
    y: 172.012,
    fill: "#fff",
    rx: 3.291
  }), /*#__PURE__*/React.createElement("rect", {
    width: 230.399,
    height: 10.165,
    x: 91.346,
    y: 187.824,
    fill: "#E2FFEA",
    rx: 5.082
  }), /*#__PURE__*/React.createElement("rect", {
    width: 98.258,
    height: 10.165,
    x: 91.346,
    y: 204.765,
    fill: "#E2FFEA",
    rx: 5.082
  }), /*#__PURE__*/React.createElement("rect", {
    width: 159.247,
    height: 10.165,
    x: 195.251,
    y: 204.765,
    fill: "#E2FFEA",
    rx: 5.082
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.659,
    height: 10.165,
    x: 360.146,
    y: 204.765,
    fill: "#E2FFEA",
    rx: 5.082
  }), /*#__PURE__*/React.createElement("rect", {
    width: 73.412,
    height: 10.165,
    x: 327.392,
    y: 187.824,
    fill: "#E2FFEA",
    rx: 5.082
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.287,
    cy: 201.377,
    fill: "#51C394",
    rx: 17.506,
    ry: 18.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.341,
    d: "M60.288 200.152a3.576 3.576 0 1 0 0-7.152 3.576 3.576 0 0 0 0 7.152ZM67.44 206.858c0 2.222 0 4.024-7.152 4.024s-7.153-1.802-7.153-4.024 3.203-4.023 7.153-4.023 7.153 1.802 7.153 4.023Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    x: 443.228,
    y: 179,
    fill: "#E2FFEA",
    opacity: 0.5,
    rx: 6.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 447.729,
    y: 183.5,
    fill: "#E2FFEA",
    rx: 6.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 25.875,
    height: 25.875,
    x: 452.791,
    y: 188.562,
    fill: "#51C394",
    stroke: "#51C394",
    strokeWidth: 1.125,
    rx: 6.188
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "m458.977 201.5 4.5 4.5 9-9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#expert_services_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 54,
    x: 84.228,
    y: 241,
    fill: "#fff",
    rx: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 9,
    x: 139.229,
    y: 255,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 9,
    x: 139.229,
    y: 270,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 9,
    x: 231.229,
    y: 270,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    x: 377.229,
    y: 270,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 9,
    x: 348.229,
    y: 255,
    fill: "#EDEDED",
    rx: 4.5
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.729,
    cy: 267,
    fill: "#3B7CC9",
    rx: 15.5,
    ry: 16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.188,
    d: "M111.727 265.916a3.166 3.166 0 1 0 .001-6.333 3.166 3.166 0 0 0-.001 6.333ZM118.06 271.854c0 1.967 0 3.563-6.333 3.563s-6.333-1.596-6.333-3.563 2.835-3.562 6.333-3.562c3.497 0 6.333 1.595 6.333 3.562Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#expert_services_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 54,
    x: 84.228,
    y: 303,
    fill: "#fff",
    rx: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 9,
    x: 139.229,
    y: 317,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 9,
    x: 139.229,
    y: 332,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 9,
    x: 231.229,
    y: 332,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    x: 377.229,
    y: 332,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 9,
    x: 348.229,
    y: 317,
    fill: "#EDEDED",
    rx: 4.5
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.729,
    cy: 329,
    fill: "#3B7CC9",
    rx: 15.5,
    ry: 16
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.188,
    d: "M111.727 327.916a3.166 3.166 0 1 0 .001-6.333 3.166 3.166 0 0 0-.001 6.333ZM118.06 333.854c0 1.967 0 3.563-6.333 3.563s-6.333-1.596-6.333-3.563 2.835-3.562 6.333-3.562c3.497 0 6.333 1.595 6.333 3.562Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#expert_services_svg__f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 54,
    x: 84.228,
    y: 365,
    fill: "#fff",
    rx: 2.914
  }), /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 9,
    x: 139.229,
    y: 379,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 9,
    x: 139.229,
    y: 394,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 9,
    x: 231.229,
    y: 394,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    x: 377.229,
    y: 394,
    fill: "#EDEDED",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 9,
    x: 348.229,
    y: 379,
    fill: "#EDEDED",
    rx: 4.5
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.729,
    cy: 391,
    fill: "#3B7CC9",
    rx: 15.5,
    ry: 16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.188,
    d: "M111.727 389.916a3.166 3.166 0 1 0 .001-6.333 3.166 3.166 0 0 0-.001 6.333ZM118.06 395.854c0 1.967 0 3.563-6.333 3.563s-6.333-1.596-6.333-3.563 2.835-3.562 6.333-3.562c3.497 0 6.333 1.595 6.333 3.562Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#expert_services_svg__g)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.518,
    height: 59.518,
    fill: "#FFB800",
    rx: 16,
    transform: "matrix(-1 0 0 1 488.746 328)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#expert_services_svg__h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.518,
    height: 38.518,
    fill: "#3BBDCF",
    rx: 10.355,
    transform: "matrix(-1 0 0 1 67.744 24)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M459.23 342.8a15.2 15.2 0 0 0-15.2 15.2 15.2 15.2 0 1 0 15.2-15.2m-17.6 15.2a17.6 17.6 0 0 1 5.155-12.445 17.59 17.59 0 0 1 19.18-3.815 17.58 17.58 0 0 1 9.525 9.525 17.599 17.599 0 0 1-28.705 19.18A17.6 17.6 0 0 1 441.63 358",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M475.229 359.066h-32v-2.133h32z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M458.162 374v-32h2.134v32zm8.734-16c0-5.795-2.083-11.526-6.168-15.315l1.269-1.371c4.539 4.214 6.765 10.48 6.765 16.686s-2.226 12.474-6.765 16.685l-1.269-1.371c4.085-3.786 6.168-9.52 6.168-15.314m-17 0c0-6.198 2.154-12.462 6.554-16.675l1.291 1.349c-3.957 3.787-5.979 9.52-5.979 15.326 0 5.802 2.022 11.538 5.979 15.325l-1.291 1.349c-4.4-4.213-6.554-10.48-6.554-16.674",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M459.228 348.555c5.787 0 11.667 1.069 15.654 3.296a.92.92 0 0 1 .444.559.925.925 0 0 1-.317.988.92.92 0 0 1-.687.196.9.9 0 0 1-.347-.111c-3.6-2.011-9.125-3.062-14.747-3.062s-11.146 1.051-14.746 3.062a.935.935 0 0 1-1.351-1.073.93.93 0 0 1 .444-.559c3.987-2.227 9.867-3.296 15.653-3.296m0 18.378c5.787 0 11.667-1.069 15.654-3.296a.92.92 0 0 0 .444-.559.925.925 0 0 0-.317-.988.92.92 0 0 0-.687-.196.9.9 0 0 0-.347.111c-3.6 2.011-9.125 3.062-14.747 3.062s-11.146-1.051-14.746-3.062a.95.95 0 0 0-.727-.11.93.93 0 0 0-.581.45.937.937 0 0 0 .401 1.29c3.987 2.229 9.867 3.298 15.653 3.298",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.229 31c-3.855 0-7 3.145-7 7 0 2.379 1.21 4.484 3.03 5.75-4.105 1.602-7.03 5.602-7.03 10.25h2c0-4.398 3.19-8.074 7.374-8.844L47.229 47h2l.625-1.844c4.185.77 7.375 4.446 7.375 8.844h2c0-4.648-2.925-8.648-7.03-10.25 1.82-1.266 3.03-3.371 3.03-5.75 0-3.855-3.145-7-7-7m0 2c2.773 0 5 2.227 5 5s-2.227 5-5 5-5-2.227-5-5 2.227-5 5-5m-1 15-1 6h4l-1-6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "expert_services_svg__a",
    width: 445,
    height: 74,
    x: 74.228,
    y: 39,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "expert_services_svg__b",
    width: 445,
    height: 74,
    x: 74.228,
    y: 101,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "expert_services_svg__c",
    width: 532.11,
    height: 113.1,
    x: 3.173,
    y: 153.956,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "expert_services_svg__d",
    width: 445,
    height: 74,
    x: 74.228,
    y: 232,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "expert_services_svg__e",
    width: 445,
    height: 74,
    x: 74.228,
    y: 294,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "expert_services_svg__f",
    width: 445,
    height: 74,
    x: 74.228,
    y: 356,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "expert_services_svg__g",
    width: 152.103,
    height: 152.102,
    x: 385.581,
    y: 292.289,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.645,
    dy: 10.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.146
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "expert_services_svg__h",
    width: 98.436,
    height: 98.436,
    x: 0.979,
    y: 0.889,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.712,
    dy: 6.848
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.979
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60756",
    result: "shape"
  })))));
};
export default SvgExpertServices;